<template>
    <span class="user-avatar" :class="sizeClass">
        <img
            v-if="hasImage"
            class="user-avatar__image"
            :src="src"
            :alt="resolvedAlt"
            :loading="loading"
            decoding="async"
            @error="handleImageError"
        >
        <span v-else class="user-avatar__fallback" aria-hidden="true">
            {{ fallbackInitial }}
        </span>
    </span>
</template>

<script>
const SIZE_TOKENS = ['xs', 'sm', 'md', 'lg', 'xl', '2xl', 'hero'];

export default {
    name: 'UserAvatar',
    props: {
        src: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        alt: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'md',
            validator: (value) => SIZE_TOKENS.includes(value),
        },
        guest: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: String,
            default: 'lazy',
            validator: (value) => ['eager', 'lazy'].includes(value),
        },
    },
    data() {
        return {
            imageFailed: false,
        };
    },
    computed: {
        hasImage() {
            return Boolean(this.src) && !this.imageFailed;
        },
        resolvedAlt() {
            return this.alt || this.name || (this.guest ? 'Гість' : 'Користувач');
        },
        fallbackInitial() {
            const fallback = this.guest ? 'Г' : '?';
            const label = String(this.name || fallback).trim();

            return (Array.from(label)[0] || fallback).toUpperCase();
        },
        normalizedSize() {
            return SIZE_TOKENS.includes(this.size) ? this.size : 'md';
        },
        sizeClass() {
            return `user-avatar--${this.normalizedSize}`;
        },
    },
    watch: {
        src() {
            this.imageFailed = false;
        },
    },
    methods: {
        handleImageError() {
            this.imageFailed = true;
        },
    },
};
</script>
